module.exports = __webpack_public_path__ + "img/magnet.17d7d17b.png";